import { render } from "./UsersPage.vue?vue&type=template&id=b7c3d7c2"
import script from "./UsersPage.vue?vue&type=script&lang=js"
export * from "./UsersPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__